<template>
  <d-description custom-class="has-box-show">
    <d-description-item>
      <template slot="left">
        <div class="is-flex is-justify-content-center">
          <b-icon
            size="is-small"
            class="mr-2"
            icon="calendar-today"
          />
          {{ $t('availability_date_show').capitalize() }}
        </div>
      </template>
      <template slot="right">
        <span v-if="!model.is_available">
          {{ $dayjs(model.availability_date).utc().format("LL") }}
        </span>
        <span v-if="model.is_available">
          {{ $t("from_now").capitalize() }}
        </span>
      </template>
    </d-description-item>
    <d-description-item>
      <template slot="left">
        <div class="is-flex is-justify-content-center">
          <b-icon
            size="is-small"
            class="mr-2"
            icon="cube-outline"
          />
          {{ $t('type').capitalize() }}
        </div>
      </template>
      <template slot="right">
        {{ $t(model.type).capitalize() }}
      </template>
    </d-description-item>
    <d-description-item>
      <template slot="left">
        <div class="is-flex is-justify-content-center">
          <b-icon
            icon="arrow-expand-all"
            size="is-small"
            class="mr-2"
          />
          {{ $t('square_feet_area').capitalize() }}
        </div>
      </template>
      <template slot="right">
        {{ model.square_feet_area }}
      </template>
    </d-description-item>
    <d-description-item>
      <template slot="left">
        <div class="is-flex is-justify-content-center">
          <b-icon
            icon="swap-vertical"
            size="is-small"
            class="mr-2"
          />

          {{ $t('floor_number').capitalize() }}
        </div>
      </template>
      <template slot="right">
        {{ model.floor_number }}
      </template>
    </d-description-item>
    <d-description-item>
      <template slot="left">
        <div class="is-flex is-justify-content-center">
          <b-icon
            icon="balcony"
            size="is-small"
            class="mr-2"
          />
          {{ $t('number_of_balconies').capitalize() }}
        </div>
      </template>
      <template slot="right">
        {{ model.number_of_balconies }}
      </template>
    </d-description-item>
    <d-description-item>
      <template slot="left">
        <div class="is-flex is-justify-content-center">
          <b-icon
            icon="dog"
            size="is-small"
            class="mr-2"
          />
          {{ $t('dog_tolerance').capitalize() }}
        </div>
      </template>
      <template slot="right">
        {{ model.dog_tolerance ? $t('yes').capitalize() : $t('no').capitalize() }}
      </template>
    </d-description-item>
    <d-description-item>
      <template slot="left">
        <div class="is-flex is-justify-content-center">
          <b-icon
            icon="cat"
            size="is-small"
            class="mr-2"
          />
          {{ $t('cat_tolerance').capitalize() }}
        </div>
      </template>
      <template slot="right">
        {{ model.cat_tolerance ? $t('yes').capitalize() : $t('no').capitalize() }}
      </template>
    </d-description-item>
  </d-description>
</template>


<script>
export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
